<template>
  <div>
    <card>
      <div slot="header" style="width:100%;display:block;padding-top: 20px">
        <flexbox class="my-1" style="height: 100px; text-align: center; " :gutter="0">
          <flexbox-item :span="4" style="color: #AAAAAA;">
            <i class="fa fa-user-circle fa-4x" style="width:100%;display:block;"></i>
          </flexbox-item>
          <flexbox-item>
            <flexbox orient="vertical">
              <flexbox-item>
                <flexbox :gutter="0">
                  <flexbox-item :span="4">{{$t('account.user.ID')}}</flexbox-item>
                  <flexbox-item>{{currentUser.ID}}</flexbox-item>
                </flexbox>
                <flexbox :gutter="0">
                  <flexbox-item :span="4">{{$t('account.user.username')}}</flexbox-item>
                  <flexbox-item>{{currentUser.username}}</flexbox-item>
                </flexbox>
                  <flexbox-item style="padding-top: 10px"><x-button 
                  style="background-color: #5890DC; width: 100px; font-size: 15px; color:white" 
                  @click.native="$router.push('/account/password')">{{$t('account.password.editPassword')}}</x-button></flexbox-item>
              </flexbox-item>
            </flexbox>
          </flexbox-item>
        </flexbox>
      </div>
      <hr>
      <hr>
      <div slot="content" class="card-padding">
        <cell :title="$t('account.user.addressList')" is-link @click.native="$router.push('/cart/address')"></cell>
        <cell :title="$t('account.user.cart')" is-link @click.native="$router.push('/cart')"></cell>
        <cell :title="$t('account.user.orderList')" is-link @click.native="$router.push('/account/order')"></cell>
        <cell :title="$t('account.credit.myCredit')" is-link @click.native="$router.push('/account/credit')" ></cell>
        <cell :title="$t('account.user.contact')" is-link @click.native="$router.push('/account/contact')" ></cell>
        <cell :title="$t('account.user.logout')" is-link  @click.native="showAlert" ></cell>
        <div v-transfer-dom>
          <alert v-model="Alert" :title="$t('account.credit.remind')" :button-text="$t('account.user.confirm')" @click.native="clearCache">{{$t('account.user.clearCache')}}</alert>
        </div>
      </div>
    </card>
  </div>
</template>
<script type="text/javascript">
import { Alert, Card, Cell, Flexbox, FlexboxItem, XButton, TransferDomDirective as TransferDom} from 'vux'
import Cookies from 'js-cookie'
import Vue from 'vue'
export default {
  name: 'Account',
  directives: {
    TransferDom
  },
  components: {
    Card,
    Cell,
    Flexbox,
    FlexboxItem,
    XButton,
    Alert
  },
  props: {},
  data() {
    return {
      currentUser: {},
      Alert: false,
    }
  },
  created() {
    document.title = `${this.$t('kol.footer.account')} - ${this.$t('kol.title')}`;
    this.$store.commit("hideFooter", false);
    this.getUserDetail();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    getUserDetail() {

      this.$store.dispatch('Account/getUserDetail', {}).then((json) => {

        if (json.status == 401) {
          Cookies.remove('token');
          this.$router.push('/login');
        } else {
          var data = JSON.stringify(json.data)
          localStorage.setItem('currentUser',data);
          this.$store.commit("updateCurrentUser", json.data);
          this.currentUser = json.data
          // console.log(JSON.parse(localStorage.getItem('currentUser')));
          // console.log(json.data);
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    clearCache() {
      Cookies.remove('token');
      Cookies.remove('role');
      Cookies.remove('locale');
      Cookies.remove('region');
      Cookies.remove('shopLink');
      Cookies.remove('redirect');
      this.setLocale('zh_hk');
      this.$router.push('/login?type=1');
    },
    setLocale(locale) {
      Vue.config.lang = locale;
      this.$cookie.set('locale', locale);
      this.$i18n.locale = Vue.config.lang;
    },
    showAlert() {
      this.Alert = !this.Alert;
    }
  },
}

</script>
<style type="text/css">
.headerContainer {
  /*  margin-top: 44px;
*/
}
</style>



// WEBPACK FOOTER //
// src/Account/containers/Account.vue